export function useCurrencyFormatter() {
  const formatCurrency = (amount: number, currencyCode = "USD", precision = 2) => {
    const currencyFormatter = Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currencyCode,
      maximumFractionDigits: precision,
      minimumFractionDigits: Math.min(precision, 2),
    })

    return currencyFormatter.format(amount)
  }

  const formatAmount = (amount: { value: number; currencyCode: string }, precision = 2) => {
    return formatCurrency(amount.value / 100, amount.currencyCode, precision)
  }

  return {
    formatCurrency,
    formatAmount,
  }
}
